import { CriteriaModel } from './CriteriaModel';
import { types } from 'mobx-state-tree';

export const PsychologistModel = types.model('PsychologistModel', {
  _id: types.identifier,
  firstName: types.string,
  lastName: types.string,
  lastMatching: types.maybeNull(types.boolean),
  inContact: types.boolean,
  profileImage: types.maybeNull(types.string),
  psychoTitle: types.maybeNull(types.string),
  psychoDescription: types.maybeNull(types.string),
  psychoLocation: types.maybeNull(types.string),
  psychoTimetable: types.maybeNull(types.string),
  isManual: types.maybeNull(types.boolean),
  score: types.maybeNull(types.number),
  ranking: types.maybeNull(types.number),
  criteria: types.maybeNull(types.array(CriteriaModel)),
});
